import {useNavigate} from "react-router-dom";
import PrimaryButton from "../../../components/Buttons/primary-button";

export default function ThirdPoster({className, ...props}) {
    const navigation = useNavigate();


    return (
        <div
            className="px-[12px] bg-[#F0FBFF] lg:py-[156px]   flex justify-center items-center box-border py-[18px] lg:px-[148px]">

            <div className={"flex flex-col lg:flex-row gap-4 justify-center items-center lg:gap-[61px]  "}>
                <div className={"flex flex-col gap-[48px]"}>
                    <div className={"flex flex-col gap-[12px] lg:gap-[24px]"}>
                        <p className={"font-semibold text-[24px] leading-[120%] lg:text-[48px]"}>
                            Take the Next Step in Your DET Prep </p>
                        <p className={'text-[12px] lg:text-[20px]'}>
                            Unlock smarter practice tools that follow your progress and highlight exactly where to
                            improve. Join a supportive community of test takers and get feedback, ideas, and real study
                            tips from others on the platform. </p>


                    </div>

                    <div className={"flex relative flex-row justify-between"}>
                        <PrimaryButton
                            onClick={() => navigation("/practice")}
                        >
                            Start My Practice Plan
                        </PrimaryButton>

                        <img
                            src={"/images/duo_march.svg"}
                            alt={"duo-mascot"}
                            className="absolute w-[150px]   -top-[22px] -right-0 lg:block hidden"
                        />
                    </div>
                </div>

                <img
                    src={require("../../../../assets/img/Image1.jpg")}
                    alt={"laptop-demo-image"}
                    className="lg:h-[370px] lg:w-[604px] w-full h-[300px]  rounded-[12px] object-cover"
                />
            </div>
        </div>)

}
